module.exports = __webpack_public_path__ + "static/media/INDUSINDBK_F1.06c59545.txt";